
























import { ShowEntry } from "@app/common";
import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class DogEntriesAlert extends Vue {
    @Prop() readonly showEntry! : ShowEntry
}
